import {Modal} from 'react-bootstrap';
import MeditationEditForm from './MeditationEditForm';


export default function MeditationEditModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Update Meditation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.form}

        <MeditationEditForm key={props.currentMeditation._id} meditation={props.currentMeditation} editMeditation={props.editMeditation} onHide={props.onHide}></MeditationEditForm>

      </Modal.Body>
    </Modal>
  );
}